export const BATCH_ACHIEVEMENT = 'batch_achievement'
export const ADMIN_BATCH_ACHIEVEMENT = 'admin_batch_achievement'



// WEBPACK FOOTER //
// ./src/constants/storage_keys.js